import React, { useState, useEffect } from 'react';
import {
  Box, Container, Typography, Button, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper, Chip, Tabs, Tab,
  Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import Header from '../components/Header';

const TYPES = ['all', 'parent', 'teacher', 'funder', 'partner', 'media', 'other'];
const TYPE_COLOR = {
  parent: '#388e3c', teacher: '#1976d2', funder: '#d32f2f',
  partner: '#7b1fa2', media: '#f57c00', other: '#616161'
};

const emptyForm = { name: '', email: '', org: '', stakeholderType: 'other', sourceInbox: '', tags: '', notes: '' };

const Contacts = () => {
  const [contacts, setContacts] = useState([]);
  const [tab, setTab] = useState('all');
  const [dialogOpen, setDialogOpen] = useState(false);
  const [form, setForm] = useState(emptyForm);

  useEffect(() => {
    const userData = localStorage.getItem('user');
    if (!userData) {
      window.location.href = '/signin?redirect=/contacts';
      return;
    }
    fetchContacts();
  }, []);

  const fetchContacts = async () => {
    try {
      const response = await fetch('/api/contacts');
      const data = await response.json();
      if (data.success) setContacts(data.contacts || []);
    } catch (err) {
      console.error('Error fetching contacts:', err);
    }
  };

  const handleCreate = async () => {
    try {
      const response = await fetch('/api/contacts', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      const data = await response.json();
      if (data.success) {
        setContacts((prev) => [data.contact, ...prev]);
        setForm(emptyForm);
        setDialogOpen(false);
      }
    } catch (err) {
      console.error('Error creating contact:', err);
    }
  };

  const filtered = tab === 'all' ? contacts : contacts.filter((c) => c.stakeholderType === tab);

  return (
    <Box>
      <Header cartQty={0} />
      <Container maxWidth="xl" sx={{ mt: 4, mb: 6 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h4" sx={{ fontWeight: 700 }}>Contacts</Typography>
          <Button variant="contained" startIcon={<AddIcon />} onClick={() => setDialogOpen(true)}>
            Add Contact
          </Button>
        </Box>

        <Tabs value={tab} onChange={(e, v) => setTab(v)} sx={{ mb: 2 }}>
          {TYPES.map((t) => (
            <Tab key={t} value={t} label={`${t[0].toUpperCase() + t.slice(1)} (${t === 'all' ? contacts.length : contacts.filter((c) => c.stakeholderType === t).length})`} />
          ))}
        </Tabs>

        <TableContainer component={Paper} variant="outlined">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Org</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Tags</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filtered.map((c) => (
                <TableRow key={c.id}>
                  <TableCell>{c.name}</TableCell>
                  <TableCell>{c.email}</TableCell>
                  <TableCell>{c.org}</TableCell>
                  <TableCell>
                    <Chip label={c.stakeholderType} size="small"
                      sx={{ backgroundColor: TYPE_COLOR[c.stakeholderType] || '#616161', color: '#fff' }} />
                  </TableCell>
                  <TableCell>{c.tags}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>

      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Add Contact</DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <TextField label="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required fullWidth />
          <TextField label="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} fullWidth />
          <TextField label="Organization" value={form.org} onChange={(e) => setForm({ ...form, org: e.target.value })} fullWidth />
          <TextField select label="Stakeholder type" value={form.stakeholderType}
            onChange={(e) => setForm({ ...form, stakeholderType: e.target.value })} fullWidth>
            {TYPES.filter((t) => t !== 'all').map((t) => (
              <MenuItem key={t} value={t}>{t[0].toUpperCase() + t.slice(1)}</MenuItem>
            ))}
          </TextField>
          <TextField label="Source inbox" value={form.sourceInbox} onChange={(e) => setForm({ ...form, sourceInbox: e.target.value })} fullWidth />
          <TextField label="Tags (comma-separated)" value={form.tags} onChange={(e) => setForm({ ...form, tags: e.target.value })} fullWidth />
          <TextField label="Notes" value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} multiline rows={2} fullWidth />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleCreate} disabled={!form.name}>Create</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Contacts;